import React from 'react';
import { Redirect as RouterRedirect, useLocation } from 'react-router-dom';
import { isExternalUrl, redirect, getCombinedSearch } from 'js/utils/url.util';

import { useGetPageRoutingURL } from 'js/hooks/useGetPageRoutingURL';

export const Redirect = (attribs) => {
    const toPage = attribs.to;
    const location = useLocation();
    const linkPath = useGetPageRoutingURL(toPage);

    if (isExternalUrl(toPage)) {
        redirect(toPage, attribs.isReplace);

        return null;
    }

    const link = new window.URL(linkPath, document.baseURI);
    const to = {
        state: location.state,
        pathname: link.pathname,
        search: getCombinedSearch(link.search, location.search),
        hash: link.hash
    };

    return <RouterRedirect {...attribs} to={to} />;
};
